import { createTypes, createAction } from 'lib/action'
const LOAD_COMP = createTypes('loadcomp', 'load')
const LOAD_DIVISION = createTypes('loaddivision', 'load')
const LOAD_DEPARTMENT = createTypes('loaddepartment', 'load')
const LOAD_SECTION = createTypes('loadsection', 'load')
const LOAD_PLANT = createTypes('loadplant', 'load')
const LOAD_DATA_DASHBOARD = createTypes('loadDataDashboard', 'load')
const LOAD_LOCATIONS_NEARBY_PLANT = createTypes(
  'loadLocationsNearByPlant',
  'load'
)

const REMOVE_LISTS = `REMOVE_LISTS`

function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

// *load comp
const loadComp = {
  request: (data) => createAction(LOAD_COMP.REQUEST, { data }),
  success: (lists) => createAction(LOAD_COMP.SUCCESS, { lists }),
  failure: () => createAction(LOAD_COMP.FAITLURE),
}
// *load division
const loadDivision = {
  request: (data) => createAction(LOAD_DIVISION.REQUEST, { data }),
  success: (lists) => createAction(LOAD_DIVISION.SUCCESS, { lists }),
  failure: () => createAction(LOAD_DIVISION.FAITLURE),
}
// *load department
const loadDepartment = {
  request: (data) => createAction(LOAD_DEPARTMENT.REQUEST, { data }),
  success: (lists) => createAction(LOAD_DEPARTMENT.SUCCESS, { lists }),
  failure: () => createAction(LOAD_DEPARTMENT.FAITLURE),
}
// *load section
const loadSection = {
  request: (data) => createAction(LOAD_SECTION.REQUEST, { data }),
  success: (lists) => createAction(LOAD_SECTION.SUCCESS, { lists }),
  failure: () => createAction(LOAD_SECTION.FAITLURE),
}
// *load plant
const loadPlant = {
  request: (data) => createAction(LOAD_PLANT.REQUEST, { data }),
  success: (lists) => createAction(LOAD_PLANT.SUCCESS, { lists }),
  failure: () => createAction(LOAD_PLANT.FAITLURE),
}

// *load data dashboard
const loadDataDashboard = {
  request: (data, loading) => createAction(LOAD_DATA_DASHBOARD.REQUEST, { data, loading }),
  success: (lists) => createAction(LOAD_DATA_DASHBOARD.SUCCESS, { lists }),
  failure: () => createAction(LOAD_DATA_DASHBOARD.FAITLURE),
}

// *load location near by plant
const loadLocationsNearbyPlant = {
  request: (data) =>
    createAction(LOAD_LOCATIONS_NEARBY_PLANT.REQUEST, { data }),
  success: (lists) =>
    createAction(LOAD_LOCATIONS_NEARBY_PLANT.SUCCESS, { lists }),
  failure: () => createAction(LOAD_LOCATIONS_NEARBY_PLANT.FAITLURE),
}

export {
  LOAD_COMP,
  loadComp,
  LOAD_DIVISION,
  loadDivision,
  LOAD_DEPARTMENT,
  loadDepartment,
  LOAD_SECTION,
  loadSection,
  LOAD_PLANT,
  loadPlant,
  LOAD_DATA_DASHBOARD,
  loadDataDashboard,
  LOAD_LOCATIONS_NEARBY_PLANT,
  loadLocationsNearbyPlant,
  REMOVE_LISTS,
  removeLists,
}
